import { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import "./header.css";

export default function Header() {
  const [isMobile, setIsMobile] = useState(false);
  const [navBarActive, setNavBarActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setNavBarActive(window.scrollY >= 80);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => {
    if (window.innerWidth <= 991) {
      setIsMobile(false);
    }
  };

  return (
    <div className={navBarActive ? "header activeNav" : "header"}>
      <button className="sideBar" onClick={() => setIsMobile(!isMobile)}>
        {isMobile ? <FaTimes className="bi-x" /> : <FaBars className="bi" />}
      </button>

      <div className="headerLogo">
        <Link className="link" to="/" onClick={handleLinkClick}>
          <h1 id="logo">
            <img src="images/rmlogo.png" alt="RM Asadulla" />
          </h1>
        </Link>
      </div>

      <nav className={isMobile ? "mobileMenu" : "headerMenu"}>
        {[
          "/",
          "/about",
          "/services",
          "/skills",
          "/recent-work",
          "/contact",
        ].map((path, index) => {
          const names = [
            "home",
            "about",
            "services",
            "skills",
            "work",
            "contact",
          ];
          return (
            <NavLink
              key={index}
              onClick={handleLinkClick}
              className="link headerMenuItem"
              to={path}
            >
              {names[index]}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
